import { tap } from 'rxjs';
import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EVENT_BUS } from '@shared/domain/tokens/event-bus.token';
import { ServiceFinalizedEvent } from '@platform/event-bus/domain/events/service-finalized.event';
import { ServiceFacade } from '@features/service/application/facades/service.facade';

@Injectable({ providedIn: 'root' })
export class PlatformOnServiceFinaliceSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);
  private readonly serviceFacade = inject(ServiceFacade);

  constructor() {
    this.eventBus.ofType(ServiceFinalizedEvent).pipe(
      tap(() => {
        this.serviceFacade.clearStore();
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }
}
